// Startup Folder Creation
export const INITIATE_STARTUP_CREATION = "INITIATE_STARTUP_CREATION";
export const STARTUP_CREATION_SUCCESS = "STARTUP_CREATION_SUCCESS";
export const STARTUP_CREATION_FAILURE = "STARTUP_CREATION_FAILURE";

// App Publish
export const INITIATE_PUBLISH_NOW = "INITIATE_PUBLISH_NOW";
export const PUBLISH_NOW_SUCCESS = "PUBLISH_NOW_SUCCESS";
export const PUBLISH_NOW_FAILURE = "PUBLISH_NOW_FAILURE";

// Publishing Page Layout
export const INITIATE_PUBLISH_PAGE_LAYOUT = "INITIATE_PUBLISH_PAGE_LAYOUT";
export const PUBLISH_PAGE_LAYOUT_SUCCESS = "PUBLISH_PAGE_LAYOUT_SUCCESS";
export const PUBLISH_PAGE_LAYOUT_FAILURE = "PUBLISH_PAGE_LAYOUT_FAILURE";

// Publishing Menu Layout
export const INITIATE_PUBLISH_MENU_LAYOUT = "INITIATE_PUBLISH_MENU_LAYOUT";
export const INITIATE_PUBLISH_LANDING_PAGE_LAYOUT =
  "INITIATE_PUBLISH_LANDING_PAGE_LAYOUT";
export const PUBLISH_MENU_LAYOUT_SUCCESS = "PUBLISH_MENU_LAYOUT_SUCCESS";
export const PUBLISH_MENU_LAYOUT_FAILURE = "PUBLISH_MENU_LAYOUT_FAILURE";
